import { Button } from "antd";

export default function Sent() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #FFF1A699", backgroundColor: "#FFF9D999" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/sent.svg" alt="" />
        <Button htmlType="button" className="yellow-btn btn-sm" type="primary">
          Follow-up
        </Button>
      </div>
      <h5> Proposal sent </h5>
      <h6> Waiting on the customer’s acceptance. </h6>
    </div>
  );
}
